<template>
  <el-drawer :visible.sync="vis" :close-on-click-modal="false" id="orderDetails" :destroy-on-close="true">
    <el-tabs type="card" v-model="tabAction">
      <el-tab-pane name="order">
        <template slot="label"><i class="el-icon-document" style="margin-right:4px"></i>订单详情</template>
        <div class="formTitle">
          {{ order.orderNo }} / {{ order.status | filterOrderStatus }}
        </div>
        <div class="box">
          <div class="item">
            <span class="title">线路名称</span>
            <span class="value">{{ order.startStationName }} - {{ order.endStationName }}</span>
          </div>
          <div class="item">
            <span class="title">车票价格</span>
            <span v-if="order.orderType == 4" class="value" style="color: #ff9900; font-weight: bold">
              ￥{{ order.lineFee + (order.schedulingType == 3 || order.railType == 2 ? "起" : "") }}
            </span>
            <span v-else class="value" style="color: #ff9900; font-weight: bold">
              ￥{{ order.lineFee }}
            </span>
          </div>
          <div class="item">
            <span class="title">订单来源</span>
            <span class="value" v-if="mixinUserInfo.platformType === 2">{{
                order.channelAlias | filterConst("CHANNELALIAS2")
              }}</span>
            <span v-else>{{
                order.channelAlias | filterConst("CHANNELALIAS")
              }}</span>
          </div>
          <div class="item">
            <span class="title">班次</span>
            <span class="value">{{ order.schedulingTime | filterTime("MM-DD") }}
              {{ order.startLineTime }} - {{ order.endLineTime }}
            </span>
          </div>
          <div class="item">
            <span class="title">实付金额</span>
            <template v-if="order.realFee || order.realFee === 0">
              <span class="util-money">￥{{ order.realFee }}</span>
              <span v-if="order.couponFee">
                (优惠券<span class="util-money-minus">-{{ order.couponFee }}</span>)</span>
            </template>
            <span class="value" v-if="!order.realFee && order.realFee !== 0">-</span>
          </div>
          <div class="item">
            <span class="title">机构名称</span>
            <span class="value">{{ order.organizationName }}</span>
          </div>
          <div class="item">
            <span class="title">联系人信息</span>
            <span class="value">
              {{ order.customerName }} {{ order.customerPhone ? ('/' + order.customerPhone) : '' }}
            </span>
          </div>
          <div class="item">
            <span class="title">退改金额</span>
            <span v-if="order.retreatFee == null && order.isTicketChanging == 0" class="value"
                  style="color: #999; font-weight: bold">-
            </span>
            <span v-if="order.status === 60">
              <span class="util-money" v-if="order.retreatFee || order.retreatFee === 0">￥{{ order.retreatFee }}</span>
              <span class="util-money" v-if="!order.retreatFee && order.retreatFee !== 0">￥0</span>
              <template v-if="order.refundType == 2">
                (平台操作)
                {{ order.retreatFee ? "" : "(无退票费)" }}
              </template>
              <template v-if="order.refundType != 2">
                {{ order.refundProportion ? "(" + order.refundProportion + "%退票费率" + ")" : "(无退票费)" }}
              </template>
            </span>

          </div>
          <div class="item">
            <span class="title">车辆号牌</span>
            <span v-if="order.licenseNo" :style="getPlateStyle(order.licenseNo)">{{ formatPlateNumber(order.licenseNo) }}</span>
            <span v-else class="value">-</span>
          </div>

          <div class="item">
            <span class="title">下单时间</span>
            <span class="value">{{ order.created | filterTime }}</span>
          </div>
          <div class="item">
            <span class="title">上车地点</span>
            <span class="value">{{ startStationName }}</span>
          </div>

          <div class="item">
            <span class="title">司机姓名</span>
            <span class="value">{{ order.driverName }}</span>
          </div>
          <div class="item">
            <span class="title">完成/取消时间</span>
            <span class="value">{{ order.finishTime | filterTime }}</span>
          </div>
          <div class="item">
            <span class="title">下车地点</span>
            <span class="value">{{ endStationName }}</span>
          </div>

          <div class="item">
            <span class="title">司机电话</span>
            <span class="value">{{ order.driverPhone }}</span>
          </div>

          <div class="item" v-if="mixinUserInfo.platformType !== 2">
            <span class="title">评分</span>
            <el-rate v-model="order.score" disabled></el-rate>
            <!-- <span class="value" v-if="order.score">{{ order.score }}星</span>
            <span class="value" v-else></span> -->
          </div>
          <div class="item">
            <span class="title">评价内容</span>
            <span class="value">{{ order.evaluateDetail || '-' }}</span>
          </div>

          <div class="item" v-if="mixinUserInfo.platformType ==2">
            <span class="title">售票员</span>
            <span class="value">{{ order.ticketSeller || '-' }}</span>
          </div>
          <div class="item" v-if="mixinUserInfo.platformType ==2">
            <span class="title">保险数量</span>
            <span class="value">{{ order.insuranceNum || '-' }}</span>
          </div>
          <div class="item" v-if="mixinUserInfo.platformType ==2">
            <span class="title">保险金额</span>
            <span class="value">¥{{ order.insuranceFee || '-' }}</span>
          </div>

          <div class="item">
            <span class="title" style="vertical-align: top">备注</span>
            <span class="value" style="display: inline-block;width: 80%;vertical-align: top;word-wrap: break-word;">
              {{ order.remark }}
            </span>
          </div>
          <div class="item">
            <span class="title" style="vertical-align: top">三方订单号</span>
            <span class="value" style="display: inline-block;width: 80%;vertical-align: top;word-wrap: break-word;">
              {{ order.openOrderNo }}
            </span>
          </div>
        </div>

        <div class="formTitle">乘客信息 / {{ order.passengerNum }} 人</div>
        <el-table style="margin-bottom: 20px" border empty-text="暂无数据" :data="passengerList">
          <el-table-column prop="customerName" label="乘客姓名"/>
          <el-table-column prop="cardType" label="证件类型" v-slot="{row}" min-width="120">
            <span v-if="row.idCard">{{ row.cardType | fliterCardType }}</span>
            <span v-else>-</span>
          </el-table-column>
          <el-table-column prop="idCard" label="证件号码" minWidth="120"/>
          <el-table-column prop="customerPhone" label="乘客电话" v-slot="{ row }">
            {{ row.customerPhone }}
          </el-table-column>
          <el-table-column v-if="order.orderType == 4" prop="ticketType" label="车票类型" v-slot="{ row }">
            {{ ['全票', '半价票', '免票(占座)', '免票(不占座)'][row.ticketType - 1] }}
          </el-table-column>

        </el-table>

      </el-tab-pane>
      <!-- 跟踪记录 -->
      <el-tab-pane name="flow">
        <template slot="label"><i class="el-icon-time" style="margin-right:4px"></i>跟踪记录</template>
        <custom-table
          ref="customTable"
          :customOptions="customOptions"
          :columns="flowColumns"
          labelWidth="135"
          :refreshShow="false"
          style="height: calc(100vh - 102px)"
          :paging="false"
        >
        <template slot-scope="{ item, row }">
          <template v-if="item.prop == 'created'">
            <span> {{ row[item.prop] | filterTime }} </span>
          </template>
          <template v-else>
            <span> {{ row[item.prop] || '-' }} </span>
          </template>
        </template>
      </custom-table>
      </el-tab-pane>
      <el-tab-pane name="map">
        <template slot="label"><i class="el-icon-map-location" style="margin-right:4px"></i>地图查看</template>
        <div id="order-map"></div>
      </el-tab-pane>
    </el-tabs>
  </el-drawer>
</template>

<script>
import AMap from "AMap";

export default {
  name: "orderDetails",
  props: {
    visible: {
      // 显隐
      default() {
        return false;
      },
    },
    order: {
      // 订单
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      tabAction: "order",
      lineInfo: null,
      map: null,
      markerBegin: null,
      markerEnd: null,
      vis: false,
      startStationName: null,
      endStationName: null,
      passengerList: [],

      visibleCustomerPhone: false,
      customerPhone: null,
      // 配置项
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/order/status",
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 50, // 每页条数
        },
        search: []
      },
      // 表头
      flowColumns: [
        { prop: "remark", label: "记录内容", minWidth: 280 },
        { prop: "operator", label: "操作人", minWidth: 150 },
        { prop: "created", label: "记录时间", minWidth: 130 },
      ],
    };
  },
  mounted() {
    // this.customOptions.params.orderId = this.order.id;
  },
  watch: {
    visible(val) {
      this.vis = val;

    },
    vis(val) {
      this.$emit("update:visible", val);
    },
    order: {
      handler(val) {
        if (val) {
          this.loadChildren(val);
          // this.record(val);
          this.address(val);
          this.customOptions.params.orderId = val.id;
          this.$nextTick(() => {
            this.$refs.customTable.listFn();
          })
        }
      },
      deep: true,
    },
    tabAction(val) {
      if (val == "map") {
        if (!this.map) {
          this.initMap();
        }

        this.drawOrderMarker();
      }
    },
  },
  methods: {

    // 地图初始化
    initMap() {
      this.map = new AMap.Map("order-map", {
        mapStyle: 'amap://styles/572516903e2f1273ed9c97f54ebacd89',
        resizeEnable: true,
        zoom: 11,
        center: new AMap.LngLat(104.065861, 30.657401),
      });
    },

    // 乘客信息
    async loadChildren(val) {
      let url = "/api/v1/manage/order/orderCustomer/customer/" + val.id;
      let data = await this.$axios.get(url);
      if (data && data.code === 1 && data.data?.length > 0) {
        this.passengerList = data.data;
      } else {
        this.$message.error("乘客信息查询错误");
      }
    },

    /* 修改联系人电话 */
    async setCustomerPhone(row) {
      if (this.customerPhone.length != 11) {
        this.$message.info("请输入11位手机号");
        return;
      }
      let url = "/api/v1/manage/order/orderCustomer/updateCustomerPhone";
      let params = {
        orderId: this.order.id,
        customerPhone: this.customerPhone
      }
      let data = await this.$axios.post(url, params);
      if (data && data.code == 1) {
        this.$message.success("已修改");
        row.customerPhone = this.customerPhone;
        this.order.customerPhone = this.customerPhone;
        this.visibleCustomerPhone = false;
      } else {
        this.$message.warning("修改失败");
      }
    },

    // 上下车地点
    async address(val) {
      let url = "/api/v1/manage/order/address/" + val.id;
      let data = await this.$axios.get(url);
      if (data && data.code === 1) {
        this.startStationName =
            (data.data[0].address || "") + " " + data.data[0].name;
        this.endStationName =
            (data.data[1].address || "") + " " + data.data[1].name;
        this.lineInfo = data.data || [];
        this.drawOrderMarker();
      }
    },

    /* 订单marker */
    drawOrderMarker() {
      if (this.tabAction != "map") {
        return;
      }
      let begin = this.lineInfo[0];
      let end = this.lineInfo[1];
      let beginContent = `<div  style="
                                padding: 10px;
                                justify-content: center;
                                align-items: center;
                                border-radius: 4px;
                                font-size: 16px;
                                color: #FFFFFF;
                                
                                box-shadow: 2px 2px 4px 0 rgba(0,0,0,0.30);
                                background-color: #4dace2;">
                                <div>上车地点：${begin.name}</div>
                            </div>`;
      let endContent = `<div  style="
                                padding: 10px;
                                justify-content: center;
                                align-items: center;
                                border-radius: 4px;
                                font-size: 16px;
                                color: #FFFFFF;
                                
                                box-shadow: 2px 2px 4px 0 rgba(0,0,0,0.30);
                                background-color: #47c147;">
                                <div>下车地点：${end.name}</div>
                          </div>`;
      if (this.markerBegin) {
        this.markerBegin.setMap(null);
        this.markerEnd.setMap(null);
      }
      this.markerBegin = new AMap.Marker({
        position: new AMap.LngLat(begin.longitude, begin.latitude),
        icon: require("@/assets/img/markerBegin.png"),
        map: this.map,
      });
      this.markerBegin.setLabel({
        offset: new AMap.Pixel(0, -6),
        content: beginContent,
        direction: "top",
      });

      this.markerEnd = new AMap.Marker({
        position: new AMap.LngLat(end.longitude, end.latitude),
        icon: require("@/assets/img/markerEnd.png"),
        map: this.map,
      });
      this.markerEnd.setLabel({
        offset: new AMap.Pixel(0, -6),
        content: endContent,
        direction: "top",
      });

      this.$nextTick(() => {
        this.map.setFitView();
      });
    },
  },
};
</script>

<style lang="less" scoped>
#orderDetails {
  /deep/ .el-drawer {
    width: 70% !important;
    overflow-x: hidden;
  }

  .formTitle {
    margin-top: 50px;
  }

  #order-map {
    width: 100%;
    height: 840px;
  }

  .el-col {
    margin: 15px 0;
  }

  .box {
    display: flex;
    flex-wrap: wrap;
    width: 100%;

    .item {
      display: flex;
      width: 33%;
      margin: 15px 0;
      font-size: 14px;

      .title {
        flex-shrink: 0;
        display: inline-block;
        width: 100px;
        margin-right: 20px;
        text-align: right;
      }

      .value {
        word-wrap: break-word;
        color: #999;

        &:empty {
          &::after {
            content: "-";
            color: rgb(233, 233, 233);
          }
        }
      }
    }
  }
}
</style>
